import { Directive, HostBinding } from '@angular/core';

@Directive({
  selector: '[app-autocomplete-state-subtitle]',
})
export class AutocompleteStateSubtitleDirective {
  // HostBinding
  @HostBinding('class') class = 'mt-2 text-gray-500';
}
